import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../../core/core.module';



import { State } from '../../../../vista-usuario/vista-usuario.state';

@Component({
  selector: 'rpe-vista-tecnico-responsable-container',
  templateUrl: './vista-tecnico-responsable-container.component.html',
  styleUrls: ['./vista-tecnico-responsable-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VistaTecnicoResponsableContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  constructor(private store: Store<State>) {}

  ngOnInit(): void {
    // todo - hacer este dispatch singleton
  }
}
